import { IconType } from 'react-icons';
import { LiaSitemapSolid } from 'react-icons/lia';

import { EditorLeftSideBarMenuProps, ModelBlocks } from 'types';
import { MenuContainer } from './style';
import useMenuBlocks from '../hooks/useMenuBlocks';
import { FLOW_TYPE } from 'constants/flow';
import { createBlockNodeDragData } from 'pages/Editor/utils/createNodeDragData';
import MenuBlock from './MenuBlock';

const ModelMenu = ({ keyword, blocks }: EditorLeftSideBarMenuProps<ModelBlocks>) => {
  const { filteredBlocks, onBlockDragStart } = useMenuBlocks({
    blocks: Object.values(blocks).reduce((acc, cnt) => [...acc, ...cnt], []),
    keyword,
    nodeType: FLOW_TYPE.NODE.NEW_NODE,
  });

  return (
    <MenuContainer>
      {filteredBlocks.map((blockData) => {
        let iconObj = {} as { Icon?: IconType; iconPath?: string };

        if (blockData.name === 'AutoModel') {
          iconObj.iconPath = `${process.env.PUBLIC_URL}/assets/svgs/huggingface_logo-noborder.svg`;
        } else {
          iconObj.Icon = LiaSitemapSolid;
        }
        return (
          <MenuBlock
            key={`model${blockData.name}`}
            {...iconObj}
            name={blockData.name}
            onDragStart={(event) =>
              onBlockDragStart(event, createBlockNodeDragData({ nodeType: FLOW_TYPE.NODE.MODEL_NODE, blockData }))
            }
          />
        );
      })}
    </MenuContainer>
  );
};

export default ModelMenu;
